<template>
  <div>
    <h1>User List</h1>

    <div
      v-if="isLoading"
      class="alert alert-info">Loading...</div>
    <div
      v-if="deletedItem"
      class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
    <div
      v-if="error"
      class="alert alert-danger">{{ error }}</div>

    <!-- <p>
      <router-link
        :to="{ name: 'UserCreate' }"
        class="btn btn-primary">Create</router-link>
    </p> -->

    <table class="table table-responsive table-striped table-hover">
      <thead>
        <tr>
          <th>Id</th>
          <th>Username</th>
          <!-- <th>salt</th> -->
          <!-- <th>password</th> -->
          <!-- <th>roles</th> -->
          <th>Testimonials</th>
          <th>Email</th>
          <!-- <th>notificationToken</th> -->
          <th>View</th>          
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in items"
          :key="item['@id']">
          <th scope="row">
            <router-link
              v-if="item"
              :to="{name: 'UserShow', params: { id: item['@id'] }}">
              {{ item['id'] }}
            </router-link>
          </th>
        <td>
            {{ item['username'] }}
        </td>
        <!-- <td>
            {{ item['salt'] }}
        </td>
        <td>
            {{ item['password'] }}
        </td> -->
        <!-- <td>
            {{ item['roles'] }}
        </td> -->
        <td>
            <template v-if="item['testimonials'] != ''">
              <!-- <div
                v-if="Array.isArray(item['testimonials'])">
                <router-link
                  v-for="link in item['testimonials']"
                  :key="link['@id']"
                  :to="`/testimonial/show/${link['@id']}`">
                  {{ link['@id'] }}
                </router-link>
              </div> -->
              <router-link                
                :to="{name: 'TestimonialList'}">
                {{ item['testimonial'].length }}
              </router-link>
            </template>
        </td>
        <td>
            {{ item['email'] }}
        </td>
        <!-- <td>
            {{ item['notificationToken'] }}
        </td> -->
          <td>
            <router-link
              :to="{name: 'UserShow', params: { id: item['@id'] }}">
              <span
                class="fa fa-search"
                aria-hidden="true"></span>
              <span class="sr-only">Show</span>
            </router-link>
          </td>
          <!-- <td>
            <router-link :to="{name: 'UserUpdate', params: { id: item['@id'] }}">
              <span
                class="fas fa-edit"
                aria-hidden="true"></span>
              <span class="sr-only">Edit</span>
            </router-link>
          </td> -->
        </tr>
      </tbody>
    </table>

    <nav class="my-3" aria-label="Page navigation" v-if="view">
      <router-link
        :to="view['hydra:first'] ? view['hydra:first'] : 'UserContactList'"
        :class="{ disabled: !view['hydra:previous'] }"
        class="btn btn-primary">
        <span aria-hidden="true">&lArr;</span> <span class="d-none d-sm-inline">First</span>
      </router-link>
      &nbsp;
      <router-link
        :to="!view['hydra:previous']? 'users' : view['hydra:previous']"        
        :class="{ disabled: !view['hydra:previous'] }"
        class="btn btn-primary">
        <span aria-hidden="true">&larr;</span> <span class="d-none d-sm-inline">Previous</span>
      </router-link>

      <router-link
        :to="view['hydra:next'] ? view['hydra:next'] : '#'"
        :class="{ disabled: !view['hydra:next'] }"
        class="btn btn-primary">
        Next <span aria-hidden="true">&rarr;</span>
      </router-link>

      <router-link
        :to="view['hydra:last'] ? view['hydra:last'] : '#'"
        :class="{ disabled: !view['hydra:next'] }"
        class="btn btn-primary">
        Last <span aria-hidden="true">&rArr;</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data() {
    return {
      successMessage: false,
      errorMessage: false, 
    }
  },
  computed: {
      ...mapFields('user/del', {
          deletedItem: 'deleted',
      }),
      ...mapFields('user/list', {
          error: 'error',
          items: 'items',
          isLoading: 'isLoading',
          view: 'view',
      }),
      routePath(){
        return this.$route.fullPath;
      },
      routeParams(){
        console.log('Get params:', this.$route);      
        return this.$route.params;
      },
  },

  mounted() {    
     // For next-previous pagination
    this.getPage(this.routePath);
    if (this.routeParams.success) {
      this.successMessage = this.routeParams.success;
    } else if (this.routeParams.error) {
      this.errorMessage = this.routeParams.error;
    } else {
      this.successMessage = false;
      this.successMessage = false;
    }
  },
  watch:{
    routePath(){
        this.getPage(this.routePath);
    }
  },
  methods: {
    ...mapActions({
      getPage: 'user/list/default',
    }),
  },
};
</script>
<style lang="scss">
  @media only screen and (min-width: 576px) {
    .table {
      display: table;      
    }
  } 
</style>


// WEBPACK FOOTER //
// src/components/user/List.vue